var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Button from "../../Button";
export var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 8px;\n  padding: 8px;\n"], ["\n  font-size: 8px;\n  padding: 8px;\n"])));
export var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: 350px;\n  overflow-y: ", ";\n"], ["\n  max-height: 350px;\n  overflow-y: ", ";\n"])), function (_a) {
    var overflow = _a.overflow;
    return (overflow ? "visible" : "auto");
});
var templateObject_1, templateObject_2;
